import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'
import LoyaltyTierRequirementCards from './LoyaltyTierRequirementCards'
import Sheet from 'components/utils/Sheet'
import type { ComponentProps } from 'react'

interface Props {
  background?: ComponentProps<typeof Sheet>['background']
}

function LoyaltyLandingPageDiscoverTiersSection({ background }: Props) {
  const intl = useIntl()

  const headingText = intl.formatMessage({
    id: 'uEdvZ_NxUQRl36U_sxfO',
    defaultMessage: 'Discover a world of rewards, one tier at a time',
    description: 'Section heading for the loyalty tier discovery section',
  })
  const bodyText = intl.formatMessage({
    id: '6YppS8FjUdMcYGRmxS7T',
    defaultMessage: 'Unlock bigger and better travel benefits as you move from Bronze to Platinum.',
    description: 'Description encouraging users to progress through loyalty tiers',
  })

  return <Sheet
    paletteType="default"
    padding="24 0 0 0"
    tabletPadding="48 0 0 0"
    background={background ?? 'light-background'}
  >
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={72}>
        <VerticalSpacer gap={32}>
          <VerticalSpacer gap={8}>
            <Heading variant="heading2" align="center">
              {headingText}
            </Heading>
            <BodyText variant="large" align="center">
              {bodyText}
            </BodyText>
          </VerticalSpacer>
          <LoyaltyTierRequirementCards />
        </VerticalSpacer>
      </Group>
    </LayoutContainer>
  </Sheet>
}

export default LoyaltyLandingPageDiscoverTiersSection
